module.exports = __webpack_public_path__ + "img/avatar.d97449b5.png";